export const ANIMATION_DURATION = 500;
